var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_8925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1067 7.99842C42.925 7.97969 42.7418 7.97969 42.56 7.99842H5.22669C4.98741 8.00211 4.74972 8.03798 4.52002 8.10509L23.7867 27.2918L43.1067 7.99842Z",
    fill: "#1A1C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.08 9.85156L25.6666 29.1849C25.167 29.6816 24.4911 29.9603 23.7866 29.9603C23.0821 29.9603 22.4063 29.6816 21.9066 29.1849L2.66664 9.99823C2.60749 10.2156 2.57613 10.4396 2.5733 10.6649V37.3316C2.5733 38.0388 2.85425 38.7171 3.35435 39.2172C3.85445 39.7173 4.53273 39.9982 5.23997 39.9982H42.5733C43.2805 39.9982 43.9588 39.7173 44.4589 39.2172C44.959 38.7171 45.24 38.0388 45.24 37.3316V10.6649C45.2294 10.3871 45.1754 10.1127 45.08 9.85156ZM7.06664 37.3316H5.2133V35.4249L14.9066 25.8116L16.7866 27.6916L7.06664 37.3316ZM42.5466 37.3316H40.68L30.96 27.6916L32.84 25.8116L42.5333 35.4249L42.5466 37.3316Z",
    fill: "#1A1C3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_8925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fa889d3b720268c10a3427508bdf069b.svg";
export { ForwardRef as ReactComponent };